import { ClosedCaseVisibility } from '../enums/closed-case-visibility.enum';

export class InvestigationTypeEntity {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly description: string,
    readonly categoryId: string,
    readonly categoryName: string,
    readonly isActive: boolean,
    readonly sortOrder: number,
    readonly checklistDisplayOnCases: boolean,
    readonly closedCaseVisibility: ClosedCaseVisibility = ClosedCaseVisibility.OpenToEveryone,
    readonly hasPublishedForm = false,
  ) {}
}
